import { Controller } from "@hotwired/stimulus"

// Manages the chat two-column layout on mobile screens.
// On small screens, toggles between the chat list (sidebar) and the conversation view.
export default class extends Controller {
  static targets = ["sidebar", "conversation"]

  connect() {
    this.mediaQuery = window.matchMedia("(max-width: 767px)")
    this.handleResize = this.handleResize.bind(this)
    this.mediaQuery.addEventListener("change", this.handleResize)

    // Show conversation immediately when a chat link is clicked on mobile
    this.element.addEventListener("click", this.trackChatClick.bind(this))

    // If page loaded with a chat_id param on mobile, show conversation
    if (this.mediaQuery.matches && new URLSearchParams(window.location.search).has("chat_id")) {
      this.showConversation()
    }
  }

  disconnect() {
    this.mediaQuery.removeEventListener("change", this.handleResize)
  }

  handleResize() {
    if (!this.mediaQuery.matches) {
      this.element.classList.remove("chat-open")
    }
  }

  trackChatClick(event) {
    // When a chat list link is tapped on mobile, immediately show the conversation
    // so the turbo frame becomes visible and can load content
    const link = event.target.closest('a[data-turbo-frame="recent-messages"]')
    if (link && this.mediaQuery.matches) {
      this.showConversation()
    }
  }

  showConversation() {
    this.element.classList.add("chat-open")
  }

  showList() {
    this.element.classList.remove("chat-open")
  }
}
